import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import validator from 'validator';
import Address from '../../../smoothr-web-app-core/models/Address';

@Component({
	selector: 'app-address-input-dialog',
	templateUrl: './app-address-input-dialog.html',
	styleUrls: ['./app-address-input-dialog.scss'],
})
export class AddressInputDialog {
	address: Address;
	private numberRegex: RegExp = /^\d+\w?$/;
	private postalRegex: RegExp = /^\d{2,5}$/;
	valid = false;

	constructor(private modalCtrl: ModalController) {}

	static async show(modalCtrl: ModalController, address: Address): Promise<Address | null> {
		const modal = await modalCtrl.create({
			component: AddressInputDialog,
			cssClass: 'auto-height address-input-dialog',
			componentProps: {
				address: {
					...address,
				},
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		return response.data as Address | null;
	}
	onNumberChange(event: any) {
		this.address.number = String(event.detail.value || '');
		this.validate();
	}
	onPostalChange(event: any) {
		this.address.postalCode = String(event.detail.value || '');
		this.validate();
	}
	submit() {
		this.modalCtrl.dismiss(this.address);
	}
	cancel() {
		this.modalCtrl.dismiss(null);
	}
	validate() {
		console.log({
			postalCode: this.address.postalCode,
			postalValid: this.postalRegex.test(this.address.postalCode),
			number: this.address.number,
			numberValid: this.numberRegex.test(this.address.number),
		});
		this.valid = this.numberRegex.test(this.address.number) && this.postalRegex.test(this.address.postalCode);
	}
}
